import * as API from '../api';

export const update = updated => {
    return API.updateUserData(updated);
};

export const updateOtherUser = updated => {
    return API.updateUserData(updated);
};

export const forceUpdate = updated => {
    return API.forceUpdate(updated);
};

export const get = () => {
    return API.getUserData();
};

export const getRanking = () => {
    return API.getRanking();
};

export const getRankingById = (id) => {
    return API.getRankingById(id);
};

export const getById = (id) => {
    return API.getUserById(id);
};

export const getStatistic = (id) => {
    return API.getStatistic(id);
};



// WEBPACK FOOTER //
// ./src/controllers/user.js